/**
 * Gera cores dinâmicas de fundo e borda para n itens,
 * seguindo um espectro HSL para garantir variedade e contraste
 * sobre fundo #231f20.
 *
 * @param numItems Quantidade de cores a gerar
 * @param seed     Opcional, desloca o espectro (pode ser inteiro)
 * @returns        backgroundColors e borderColors em HSLA
 */
export const generateDynamicChartColors = (
  numItems: number,
  seed: number = 0
): { backgroundColors: string[]; borderColors: string[] } => {
  const backgroundColors: string[] = [];
  const borderColors: string[] = [];

  // Usa um número primo para 'embaralhar' o seed no hue de base
  const baseHue = (seed * 137) % 360;

  for (let i = 0; i < numItems; i++) {
    // Divide igualmente o espectro de 360° entre os itens
    const hue = (baseHue + (360 * i) / numItems) % 360;

    // Saturação levemente variada entre 65% – 75% para mais diversidade
    const saturation = 65 + ((seed + i * 5) % 11);

    // Lightness fixo para fundo e ligeiramente maior para borda
    const lightBG = 50;
    const lightBorder = 60;

    backgroundColors.push(
      `hsla(${hue.toFixed(0)}, ${saturation}%, ${lightBG}%, 0.6)`
    );
    borderColors.push(
      `hsla(${hue.toFixed(0)}, ${saturation}%, ${lightBorder}%, 1)`
    );
  }

  return { backgroundColors, borderColors };
};
